import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=e0d8cf2a&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0d8cf2a')) {
      api.createRecord('e0d8cf2a', component.options)
    } else {
      api.reload('e0d8cf2a', component.options)
    }
    module.hot.accept("./Keyboard.vue?vue&type=template&id=e0d8cf2a&", function () {
      api.rerender('e0d8cf2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/Keyboard.vue"
export default component.exports